import { ElementRef, Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class ScrollService {
	private static readonly DEFAULT_SCROLL_OPTIONS: ScrollIntoViewOptions = {
		behavior: 'smooth',
		block: 'start',
		inline: 'nearest'
	};

	static scrollByElementRef(
		scrollElementRef: ElementRef,
		scrollOpts: ScrollIntoViewOptions = ScrollService.DEFAULT_SCROLL_OPTIONS
	): void {
		scrollElementRef.nativeElement.scrollIntoView(scrollOpts);
	}

	static scrollByElement(
		scrollElement: HTMLElement,
		scrollOpts: ScrollIntoViewOptions = ScrollService.DEFAULT_SCROLL_OPTIONS
	): void {
		scrollElement.scrollIntoView(scrollOpts);
	}

	static scrollByQuerySelector(
		selector: string,
		scrollOpts: ScrollIntoViewOptions = ScrollService.DEFAULT_SCROLL_OPTIONS
	): void {
		document.querySelector(selector).scrollIntoView(scrollOpts);
	}

	static scrollToTopOfBody(
		scrollOpts: ScrollIntoViewOptions = ScrollService.DEFAULT_SCROLL_OPTIONS
	): void {
		document.querySelector('body').scrollIntoView(scrollOpts);
	}
}
